import React from "react";
import "./FirstSection.css";
import { Link } from "react-router-dom";
import heroBg from "../../assets/parallax-bg-01.jpg";
import aboutBg from "../../assets/parallax-bg-02.jpg";

import about1 from "../../assets/about-01.jpg";
import about2 from "../../assets/about-02.jpg";

const FirstSection = () => {
  return (
    <>

      {/* TOP SECTION */}

      <section className="first-section">

        <div
          className="first-section-bg"
          style={{ backgroundImage: `url(${heroBg})` }}
        ></div>

        <div className="first-section-overlay"></div>

        <div className="first-section-content">

          <h1>FIDIN VENTURES PVT. LTD.</h1>

          <p>Building India's Future</p>

<Link to="/about" className="discover-btn">
  DISCOVER MORE
</Link>

        </div>

      </section>

      {/* ABOUT SECTION */}

      <section
        className="about-section"
        style={{
          backgroundImage: `
          linear-gradient(rgba(26,26,26,0.92), rgba(26,26,26,0.92)),
          url(${aboutBg})
          `
        }}
      >

        <div className="about-container">

          {/* BOX 1 */}

          <div className="about-box">

            <img src={about1} alt="FIDIN Construction" />

            <h3>FIDIN Construction</h3>

            <p>
              It is a leading construction company with over 15 years
              of experience. We specialize in residential, commercial
              and industrial projects with modern technology and timely
              completion.
            </p>

          </div>

          {/* BOX 2 */}

          <div className="about-box">

            <img src={about2} alt="FIDIN Ventures" />

            <h3>FIDIN Ventures</h3>

            <p>
              FIDIN Ventures is an engineering driven infrastructure
              company delivering renewable energy, power transmission,
              and industrial EPC solutions across India.
            </p>

          </div>

        </div>

      </section>

      {/* BUTTON SECTION */}

      <section className="button-section">

<Link to="/projects" className="primary-btn">
  Explore Our Projects
</Link>

<Link to="/founder" className="secondary-btn">
  Partner With Us
</Link>

      </section>

    </>
  );
};

export default FirstSection;